import { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import F2AdditionalInformation from './F2AdditionalInformation/F2AdditionalInformation';
import F1DefinitionsList from './F1DefinitionsList/F1DefinitionsList';

const FurtherInformation = ({ data, refetchMonitoringData,vesselMstId }) => {
    const [expandedPanel, setExpandedPanel] = useState('panel1');

    const autoSaveForF1 = useRef();
    const autoSaveForF2 = useRef();

    const handleChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;
        if (expandedPanel === 'panel1' && autoSaveForF1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForF1.current.submitAndCheck();
        } else
            if (expandedPanel === 'panel2' && autoSaveForF2.current?.submitAndCheck) {
                isSubmitSuccess = await autoSaveForF2.current.submitAndCheck();
            }
        if (!isSubmitSuccess) return;

        setExpandedPanel(isExpanded ? panel : false);
    };


    const methods = useForm({
        mode: 'onBlur',
        defaultValues: {
        },
    });

    const renderTitleWithIcon = (panel, title) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {expandedPanel === panel ? '−' : '+'}
            </span>
            <p className="fuel-cons">{title}</p>
        </div>
    );

    return (
        <FormProvider {...methods}>
            <form>
                <Accordion defaultExpanded expanded={expandedPanel === 'panel1'} onChange={handleChange('panel1')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel1', 'F.1 List of definitions and abbreviations')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <F1DefinitionsList
                            f1Abbreviations={data?.f1Abbreviations}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForF1}
                        />
                    </AccordionDetails>
                </Accordion>

                <Accordion expanded={expandedPanel === 'panel2'} onChange={handleChange('panel2')} className="mt-3">
                    <AccordionSummary
                        className="accordion-header"
                    >
                        {renderTitleWithIcon('panel2', 'F.2 Additional information')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <F2AdditionalInformation
                            f2AdditionalInfo={data?.f2AdditionalInfo}
                            vesselMstId={vesselMstId}
                            refetchMonitoringData={refetchMonitoringData}
                            ref={autoSaveForF2}
                        /></AccordionDetails>
                </Accordion>
            </form>
        </FormProvider>
    );
};

export default FurtherInformation;